import ExamFailModal from 'Components/ExamFailModal'
import ExamPassModal from 'Components/ExamPassModal'
import { userState } from 'Constants/userRegistrationStatus'
import { useLogoutUserMutation } from 'Services/API/posp.api'
import { ToastService } from 'Services/toast.service'
import { useAppSelector } from 'app/hooks'
import { resetUser, updateUserState } from 'features/Authentication'
import React, { useEffect, useState } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

const GeneralExamResultPage = () => {
  const store = useAppSelector((store) => store.user)
  const { examResult } = store
  const navigate = useNavigate()
  const { isLoggedIn, authenticatedUser } = useSelector((state: any) => state.user)
  const dispatch = useDispatch()
  const location = useLocation()
  // LOGOUT FUNCTIONALITIES

  // const [logoutUser] = useLogoutUserMutation({})

  // const handleLogout = async () => {
  //   try {
  //     const logoutUserResp = await logoutUser({
  //       idle: true,
  //     })
  //     // console.log(logoutUserResp)
  //     if (logoutUserResp?.data?.status && isLoggedIn) {
  //       ToastService.showInfoToast({
  //         title: 'Session Timeout',
  //         message: 'You have been auto logout due to inactivity',
  //       })
  //       navigate('/')
  //       localStorage.clear()
  //       sessionStorage.clear()
  //       dispatch(resetUser())
  //       dispatch(updateUserState(userState))
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }
  // IDLE TIMER FOR AUTO LOGOUT
  // const [state, setState] = useState<string>('Active')
  // const [count, setCount] = useState<number>(0)
  // const [remaining, setRemaining] = useState<number>(0)

  // const onIdle = () => {
  //   // setState('Idle')
  //   handleLogout()
  // }

  // const onActive = () => {
  //   setState('Active')
  // }

  // const onAction = () => {
  //   setCount(count + 1)
  // }

  // const { getRemainingTime } = useIdleTimer({
  //   onIdle,
  //   onActive,
  //   onAction,
  //   timeout: 10_000 * 6 * 5,
  //   throttle: 500,
  // })

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setRemaining(Math.ceil(getRemainingTime() / 1000))
  //   }, 500)

  //   return () => {
  //     clearInterval(interval)
  //   }
  // })
  return (
    <>
      {examResult.passed === true ? (
        <ExamPassModal
          isOpen={true}
          score={examResult.score}
          total={50}
          certificateLink={examResult.certificate_url}
        />
      ) : (
        <ExamFailModal isOpen={true} score={examResult.score} total={50} minScore={25} />
      )}
    </>
  )
}

export default GeneralExamResultPage
